import { render, staticRenderFns } from "./taskToRead.vue?vue&type=template&id=0a2389a4&scoped=true&"
import script from "./taskToRead.vue?vue&type=script&lang=js&"
export * from "./taskToRead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2389a4",
  null
  
)

export default component.exports